var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPortfoliosWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_340_1163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.75V6.41667C13.75 6.65978 13.8466 6.89294 14.0185 7.06485C14.1904 7.23676 14.4236 7.33333 14.6667 7.33333H18.3333",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.5833H10.0833C9.5971 15.5833 9.13079 15.3902 8.78697 15.0464C8.44315 14.7025 8.25 14.2362 8.25 13.75V4.58333C8.25 4.0971 8.44315 3.63079 8.78697 3.28697C9.13079 2.94315 9.5971 2.75 10.0833 2.75H13.75L18.3333 7.33333V13.75C18.3333 14.2362 18.1402 14.7025 17.7964 15.0464C17.4525 15.3902 16.9862 15.5833 16.5 15.5833Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 15.5832V17.4165C14.6668 17.9027 14.4737 18.369 14.1299 18.7129C13.786 19.0567 13.3197 19.2498 12.8335 19.2498H6.41683C5.9306 19.2498 5.46428 19.0567 5.12047 18.7129C4.77665 18.369 4.5835 17.9027 4.5835 17.4165V8.24984C4.5835 7.76361 4.77665 7.29729 5.12047 6.95347C5.46428 6.60966 5.9306 6.4165 6.41683 6.4165H8.25016",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_340_1163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfoliosWhite);
export default __webpack_public_path__ + "static/media/Icon_Portfolios_White.87dc4de1a3e3fdf7edc4ab83ce410c13.svg";
export { ForwardRef as ReactComponent };